export default "/packs/images/carabiner-4~8a0fd1f9ee13e050a48ef10d1eee47fe.png";